import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { asyncAddMember } from "./members";


const initialState = {
    data: {
        pubkey: "",
        room_id: "",
        message: "",
        signature: "",
    }
}


export const asyncCheckAuth = createAsyncThunk('auth/checkAuth', async (authInfo: AuthCallRequest, thunkAPI) => {
    
    thunkAPI.dispatch(asyncAddMember({ pubkey: authInfo.pubkey, is_local: true, is_audio_on: true, is_video_on: true, display_name: "", avatar: "", stream: undefined, }));
    thunkAPI.dispatch(setAuth(authInfo));
    return authInfo;
})


const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        setAuth(state, action) {
            state.data = action.payload;
        }
    },
});

export const { setAuth } = authSlice.actions;

export default authSlice.reducer;